// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transformsfields {
  display: grid;
  grid-template-columns: 100%;
  grid-row-gap: 30px;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 40px;
}

.Heading {
  margin-right: 60%;
}

.Heading1 {
  display: flex;
  align-items: center;
}

.transformsbutton {
  text-align: center;
  background-color: #8b5ccc;
  color: white;
  border: none;
  padding: 5px 27px;
  height: 36.56px;
  font-size: 0.9rem;
  margin-bottom: 30px;
  border-radius: 5px;
}

.transformsbutton:hover {
  background-color: rgba(54, 3, 125, 0.919);
  color: white;
}

.transformsfieldbutton {
  display: flex;
  padding: 10px;
  grid-column-gap: 50px;
  margin-left: 20px;
}

.fields {
  font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/etlModule/transforms/transforms.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".transformsfields {\n  display: grid;\n  grid-template-columns: 100%;\n  grid-row-gap: 30px;\n  justify-content: center;\n  margin-top: 10px;\n  margin-bottom: 40px;\n}\n\n.Heading {\n  margin-right: 60%;\n}\n\n.Heading1 {\n  display: flex;\n  align-items: center;\n}\n\n.transformsbutton {\n  text-align: center;\n  background-color: #8b5ccc;\n  color: white;\n  border: none;\n  padding: 5px 27px;\n  height: 36.56px;\n  font-size: 0.9rem;\n  margin-bottom: 30px;\n  border-radius: 5px;\n}\n\n.transformsbutton:hover {\n  background-color: rgba(54, 3, 125, 0.919);\n  color: white;\n}\n\n.transformsfieldbutton {\n  display: flex;\n  padding: 10px;\n  grid-column-gap: 50px;\n  margin-left: 20px;\n}\n\n.fields {\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
